// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"ce05522f","576":"f7996a3e"}[chunkId] + ".chunk.css";
};